import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'smoke',
      d: 'M0,-8h1.5v0.5h-1.5zM-0.5,-7.5h2v0.5h-2zM-1,-7h2.5v1h-2.5zM-1,-6h2v0.5h-2zM-1.5,-5.5h2v0.5h-2zM-1,-5h1.5v0.5h-1.5zM0,-4h1.5v0.5h-1.5z',
    },
  ],
  pixels: 31,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
